export default function CubeIcon(props) {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.623 27.2812L43.9997 46.0179L76.1564 27.3912"
        stroke="white"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 79.2371V45.9805"
        stroke="white"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4123 9.09469L16.8323 19.948C12.3956 22.4047 8.76562 28.5647 8.76562 33.6247V54.3414C8.76562 59.4014 12.3956 65.5613 16.8323 68.018L36.4123 78.908C40.5923 81.218 47.449 81.218 51.629 78.908L71.209 68.018C75.6456 65.5613 79.2756 59.4014 79.2756 54.3414V33.6247C79.2756 28.5647 75.6456 22.4047 71.209 19.948L51.629 9.05802C47.4123 6.74802 40.5923 6.74802 36.4123 9.09469Z"
        stroke="white"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
